import _ from 'lodash';

export function getDefaultRequestedDate(caseInfo) {
  let result = _.get(caseInfo, ['response', 'creationDatetime'], null);
  return result;
}

export function getDefaultExecutedDate(caseInfo) {
  let result = _.get(caseInfo, ['response', 'reportValidationEndedDate'], new Date().toISOString());
  return result;
}

export function getEventColor(event) {
  switch (event) {
    case 'ChangeRequested': return 'orange';
    case 'ChangeExecuted': return 'green';
    case 'ChangeChecked': return 'violet';
    case 'ChangeCharged': return 'red';
    case 'ChangePaid': return 'blue';
    default:
      throw new Error(`Unknown event '${event}'`)
  }
}



// WEBPACK FOOTER //
// ./src/components/Sales/case/caseServiceLogUtils.js